<template>
  <nav role="navigation" :class="'nav--' + $store.getters['auth/role']">
    <div v-if="$store.getters['auth/isRole']('ROLE_AGENT') == true" class="header-container">
      <Menu></Menu>
      <div class="header">
        <a class="header__burger" href="" @click.prevent="toggleMenu()">
          <img class="" alt="" src="/static/img/pictos/burger.svg" />
        </a>
        <router-link :to="{ name: 'Home' }" class="header__logo">
          <img class="logo" alt="" src="/static/img/logo.svg" />
        </router-link>
        <div class="header__search-container search">
          <div class="search__icon-container" @click="toggleSearch()">
            <img class="search__icon" src="/static/img/pictos/loupe.svg" />
          </div>
          <input
            type="text"
            name=""
            placeholder="Rechercher un produit"
            value=""
            v-model="searched"
            @keyup="search(searched)"
            class="search__field"
            ref="keyword"
          />
          <a
            href=""
            class="reset-search"
            v-show="this.$refs.keyword && this.$refs.keyword.value != ''"
            ><img src="/static/img/pictos/fermer-bleu.svg" @click.prevent="resetSearch()"
          /></a>
          <input
            type="submit"
            name=""
            value="OK"
            class="search__submit"
            @click.prevent="search(searched)"
          />
        </div>
      </div>
      <SearchResults
        v-if="searched"
        :loading="loading"
        :searched="searched"
        :nav="true"
      ></SearchResults>
    </div>
    <div
      v-if="$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true"
      class="header-container mobile"
    >
      <Menu></Menu>
      <div class="header">
        <div class="header__main">
          <div class="header__first">
            <a class="header__burger" href="" @click.prevent="toggleMenu()">
              <img class="" alt="" src="/static/img/pictos/burger.svg" />
            </a>
            <router-link :to="{ name: 'Home' }" class="header__logo">
              <img class="logo" alt="" src="/static/img/logo.svg" />
            </router-link>
          </div>
          <div class="header__second">
            <div class="squares">
              <div class="square square--first"></div>
              <div class="square square--second"></div>
              <div class="icon-container" @click="toggleSearch()">
                <div class="icon-container__picto">
                  <img class="icon" src="/static/img/pictos/loupe.svg" />
                </div>
              </div>
            </div>
          </div>
          <div class="header__third">
            <router-link :to="{ name: 'CartPage' }" class="header__cart-content cart-content">
              <div class="cart-content__picto">
                <span>{{ $store.getters["order/getCartNbItems"] }}</span>
                <img class="" src="/static/img/pictos/panierssrond.svg" />
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="
        $store.getters['auth/isRole']('ROLE_ADMIN') == true ||
        $store.getters['auth/isRole']('ROLE_SUPER_ADMIN') == true
      "
      class="header-container admin"
    >
      <div class="header">
        <router-link :to="{ name: 'Home' }" class="header__logo">
          <img class="logo" alt="" src="/static/img/logo.svg" />
        </router-link>
        <a class="header__account" @click.prevent="AdminAccountMenu = !AdminAccountMenu" href="">
          <img class="logo" alt="" src="/static/img/pictos/compte.svg" />
          <span>Mon compte</span>
        </a>
        <div class="header__my-account-menu" v-show="AdminAccountMenu == 1">
          <router-link class="" :to="{ name: 'Logout' }"> Se déconnecter </router-link>
          <router-link :to="{ name: 'Profile' }" class=""> Paramètres du compte </router-link>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { languages_trad } from "@/traductions/config";
import { defaultLocale } from "@/traductions/config";
import SearchResults from "@/components/Global/SearchResults";

import Menu from "@/components/Global/Menu";

export default {
  name: "Nav",
  components: {
    Menu,
    SearchResults,
  },
  data() {
    return {
      locale: this.$i18n.locale,
      languages: languages_trad,
      searched: "",
      loading: 0,
      AdminAccountMenu: 0,
    };
  },
  methods: {
    // Affiche ou ferme le menu
    toggleMenu() {
      this.$store.dispatch("toggleMenu");
    },
    // Affiche la page de recherche pour les techniciens, et la ferme au clic suivant
    toggleSearch() {
      this.$store.dispatch("toggleSearch");
    },
    // Vide le champ de recherche
    resetSearch() {
      const self = this;
      this.$store.dispatch("search/setResults", null).then(function () {
        self.$refs.keyword.value = "";
        self.searched = "";
      });
    },
    // Méthode de recherche
    search(searched) {
      if (searched != "") {
        this.$store.dispatch("showSearch");
      } else {
        this.$store.dispatch("hideSearch");
      }
      // Si on n'est pas déjà en train d'effectuer une recherche
      if (this.loading == 0) {
        // On lance la recherche donc on passe l'info au composant
        this.loading = 1;

        // envoi de la requête au back avec le mot tapé en paramètre post (predicate)
        this.$http
          .post("product/search", {
            predicate: searched,
          })
          .then((response) => {
            // Dans le retour Ajax on enregistre les résultats de la recherche avec le résultat retourné par le back
            this.$store.dispatch("search/setResults", response.data);

            // On indique au composant que la recherche est terminée pour qu'une nouvelle recherche puisse être faite.
            this.loading = 0;
          })
          .catch((error) => {
            // Erreur lors de la requête AJAX : on indique que la recherche est terminée
            this.loading = 0;
          });
      }
    },
  },
  watch: {
    locale(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("defaultLocale", lang);
    },
  },
};
</script>


<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";
.header-container {
  background-color: $color2;
  height: 135px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 75%;
  align-items: top;
  position: fixed;
  top: 0;
  z-index: 20;
  .header {
    background-color: $color2;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    z-index: 101;
    &__burger {
      width: 30px;
      display: block;
      height: 22px;
      margin-left: 30px;
      margin-bottom: 5px;
    }
    &__logo {
      margin-left: 65px;
      font-family: "ClanFFBlack";
      font-size: 48px;
      color: white;
      &:hover {
        text-decoration: none;
      }
      .logo {
        width: 120px;
      }
    }
    &__account {
      justify-self: flex-end;
      margin-right: 65px;
      text-align: center;
      img {
        height: 50px;
        display: block;
        margin: 0 auto;
      }
      span {
        text-transform: uppercase;
        color: white;
        font-size: 11px;
        font-family: "ClanProBold";
      }
      &:hover {
        text-decoration: none;
      }
    }
    &__search-container {
      margin: 0 8%;
      width: 100%;
      flex: 1;
      display: flex;
      background-color: white;
      border-top-right-radius: 30px;
      border-bottom-right-radius: 30px;
      position: relative;
    }
    .search {
      &__field {
        height: 60px;
        border: none;
        width: 100%;
        margin-left: 60px;
        outline: none;
        font-size: 12px;
      }
      &__submit {
        width: 80px;
        border-radius: 30px;
        text-align: center;
        background-color: $color3;
        color: white;
        border: none;
        outline: none;
      }
      &__icon-container {
        width: 60px;
        height: 60px;
        background-color: $mystockblue;
        text-align: center;
        transform: rotate(45deg);
        position: absolute;
        top: 0;
        left: 0;
        margin-top: 0;
        margin-left: -30px;
        img {
          transform: rotate(-45deg);
          margin-top: 20px;
          width: 20px;
        }
      }
      .reset-search {
        position: absolute;
        top: 17px;
        right: 80px;
        img {
          width: 10px;
        }
      }
    }
  }
  &.admin {
    width: 100%;
    height: 100px;
    .header {
      justify-content: space-between;
      &__my-account-menu {
        background-color: #fff;
        position: fixed;
        right: 30px;
        top: 90px;
        width: auto;
        padding: 10px 20px 15px;
        width: 160px;
        line-height: 1;
        border: 1px solid $grisclair;
        a {
          font-size: 11px;
          margin: 10px 0;
          color: $grisfonce;
          display: block;
          &:last-of-type {
            margin-bottom: 0;
          }
        }
      }
    }
  }
  &.mobile {
    width: 100%;
    height: 75px;
    background: transparent;
    .header {
      background: transparent;
      &__main {
        display: flex;
        flex-wrap: no-wrap;
        width: 100%;
        height: 75px;
        overflow-y: visible;
        position: relative;
      }
      .header__first {
        width: calc(50% - 52px);
        height: 100%;
        background-color: $color2;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        align-items: center;
      }
      .header__second {
        width: 104px;
        height: 100%;
        z-index: 2;
        overflow-y: visible;
        .squares {
          position: relative;
          height: 100%;
          width: 100%;
        }
        .square {
          width: 105px;
          height: 105px;
          background-color: $color2;
          display: block;
          position: absolute;
          bottom: 22px;
          &--first {
            transform: rotate(45deg);
            left: -52px;
          }
          &--second {
            transform: rotate(-45deg);
            right: -52px;
          }
        }
      }
      .header__third {
        width: calc(50% - 52px);
        display: flex;
        align-items: center;
        justify-content: flex-end;
        height: 100%;
        background-color: $color2;
        z-index: 3;
      }
      &__logo {
        font-size: 25px;
        margin-left: 20px;
        z-index: 3;
      }
      .icon-container {
        width: auto;
        height: auto;
        padding: 6px;
        background: transparent;
        text-align: center;
        transform: rotate(45deg);
        position: fixed;
        top: 39px;
        left: 50%;
        margin-top: 0;
        margin-left: -36px;
        &__picto {
          background-color: $color1;
          width: 60px;
          height: 60px;
          img {
            transform: rotate(-45deg);
            margin-top: 20px;
            width: 20px;
          }
        }
      }
      .cart-content {
        width: 110px;
        background-color: $color3;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        &__picto {
          position: relative;
          span {
            display: block;
            background-color: white;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            position: absolute;
            top: -12px;
            right: -12px;
            font-family: "ClanFFBlack";
            font-size: 12px;
            color: $rouge;
            line-height: 26px;
            text-align: center;
          }
          img {
            width: 35px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1680px) {
  .header-container {
    width: calc(100% - 415px);
    &.admin {
      width: 100%;
    }
  }
  .main__sidebar {
    width: 415px;
  }
}

@media screen and (max-width: 530px) {
  .header-container {
    &.mobile {
      .header {
        .header__first {
          .header__logo {
            flex: 1;
          }
          .logo {
            width: 100%;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 400px) {
  .header-container {
    &.mobile {
      .header {
        .header__first {
          width: calc(50% - 32px);
          .header__burger {
            margin-left: 15px;
          }
          .header__logo {
            margin-left: 15px;
          }
        }
        .header__second {
          width: 64px;
          .icon-container {
            top: 56px;
            padding: 0;
            width: 36px;
            height: 36px;
            margin-left: -18px;
            &__picto {
              width: 36px;
              height: 36px;
              img {
                margin-top: 8px;
                width: 15px;
              }
            }
          }
        }
        .header__third {
          width: calc(50% - 32px);
        }
      }
    }
  }
}
.nav--ROLE_SUPER_ADMIN,
.nav--ROLE_ADMIN {
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Global/Nav.vue